import React from "react";

import Login from "../Login";

// A recuperação de senha agora vive na mesma tela do login (modo "recover").
// Mantemos a rota /forgot funcionando para links diretos/bookmarks antigos.
const Forgot: React.FC = () => <Login initialMode="recover" />;

export default Forgot;
